import moment from "moment";
import { Format } from "./enums";

export const serverDateToUi = (date) => {
  if (date) {
    return moment(date).format(Format.DayMonthYearFormat)
  }
  return ''
};